export const ENABLE_FETCH_AUTOCOMPLETE = 'AUTOCOMPLETE:ENABLE_FETCH';
export const DISABLE_FETCH_AUTOCOMPLETE = 'AUTOCOMPLETE:DISABLE_FETCH';
export const FETCH_PRODUCT_ATTRIBUTES = 'PRODUCT_ATTRIBUTES:FETCH';
export const REFRESH_PRODUCT_ATTRIBUTES = 'PRODUCT_ATTRIBUTES:REFRESH';
export const FETCH_PRODUCT_ATTRIBUTE_VALUES = 'PRODUCT_ATTRIBUTE_VALUES:FETCH';
export const REFRESH_PRODUCT_ATTRIBUTE_VALUES = 'PRODUCT_ATTRIBUTE_VALUES:REFRESH';
export const FETCH_COLLECTIONS = 'COLLECTIONS:FETCH';
export const REFRESH_COLLECTIONS = 'COLLECTIONS:REFRESH';
